import { Preferences } from '@capacitor/preferences';

const SESSION_KEY = 'ficharbot_user_v1';

/**
 * Lee la sesión del usuario desde Preferences (nativo en iOS/Android,
 * localStorage en web). Migra automáticamente desde claves antiguas.
 */
export async function getSession(): Promise<any | null> {
  try {
    // Migración desde localStorage legacy ('user' y 'ficharbot_user_v1')
    for (const legacyKey of ['user', SESSION_KEY]) {
      const legacyRaw = localStorage.getItem(legacyKey);
      if (legacyRaw) {
        await Preferences.set({ key: SESSION_KEY, value: legacyRaw });
        localStorage.removeItem(legacyKey);
        return JSON.parse(legacyRaw);
      }
    }

    const { value } = await Preferences.get({ key: SESSION_KEY });
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

/**
 * Guarda la sesión del usuario en Preferences nativo.
 */
export async function saveSession(userData: any): Promise<void> {
  try {
    await Preferences.set({ key: SESSION_KEY, value: JSON.stringify(userData) });
  } catch (e) {
    console.error('Error guardando sesión:', e);
  }
}

/**
 * Elimina la sesión (logout).
 */
export async function clearSession(): Promise<void> {
  await Preferences.remove({ key: SESSION_KEY });
  // Por si quedara algún rastro legacy
  localStorage.removeItem('user');
  localStorage.removeItem(SESSION_KEY);
}
